import {StylesConfig} from 'react-select'

export const colourStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    background: '#f5f8fa',
    border: 'none',
    margin: '0',
    padding: '0',
    boxShadow: 'none',
  }),
  singleValue: (styles) => ({
    ...styles,
    color: '#464E5F',
    border: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#B5B5C4',
    fontSize: '11px',
  }),
  option: (styles) => ({
    ...styles,
    borderRadius: '5px',
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: '#0088ff',
      borderRadius: '5px',
      border: '1px solid #000',
    }
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: '#fff',
    placeContent: 'center',
    textIndent: '6px',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: '#fff',

    ':hover': {
      backgroundColor: '#ff0500',
      color: '#fff',
      borderLeft: '1px solid #000',
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
    },
  }),
}

export const colourStyles2: StylesConfig = {
  control: (styles) => ({
    ...styles,
    background: '#fff',
    border: 'none',
    margin: '0',
    padding: '0',
    boxShadow: 'none',
  }),
  singleValue: (styles) => ({
    ...styles,
    color: '#464E5F',
    border: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#B5B5C4',
  }),
  option: (styles) => ({
    ...styles,
    borderRadius: '5px',
  }),
}
